export type DatadogRum = typeof import("@datadog/browser-rum-slim").datadogRum;

type RumCallback = (rum: DatadogRum) => void;

const MAX_QUEUED = 100;

export interface RumCalls {
  rumCall: (call: RumCallback) => void;
  drainRumCalls: (rum: DatadogRum) => void;
}

/**
 * Holds RUM calls until the SDK loads, so no caller imports it and pulls it
 * into the startup graph. A page where RUM never starts keeps the queue and
 * sends nothing, as Datadog's own pre-init buffer does.
 */
export function createRumCalls(): RumCalls {
  let loaded: DatadogRum | null = null;
  const queue: RumCallback[] = [];
  return {
    rumCall: (call) => {
      if (loaded != null) {
        call(loaded);
        return;
      }
      if (queue.length >= MAX_QUEUED) {
        queue.shift();
      }
      queue.push(call);
    },
    drainRumCalls: (rum) => {
      loaded = rum;
      for (const call of queue.splice(0)) {
        call(rum);
      }
    },
  };
}

export const { rumCall, drainRumCalls } = createRumCalls();
